import type { HttpErrorContext } from '@/domains/http/httpError.entity';
import type { AxiosError } from 'axios';
import type { HttpErrorDto } from '../dtos/httpError.dto';

/**
 * Mapper para transformar errores HTTP entre capas
 * Responsabilidad única: Mapeo de datos entre DTO e entidades de dominio
 */
export class HttpErrorMapper {
  /**
   * Mapea AxiosError a DTO de infraestructura
   * Extrae información relevante del error de Axios
   */
  static axiosErrorToDto(error: AxiosError): HttpErrorDto {
    return {
      status: error.response?.status || 0,
      url: error.config?.url,
      method: error.config?.method?.toUpperCase(),
      message: error.message,
      code: error.code,
    };
  }

  /**
   * Mapea DTO a entidad de dominio
   * Transforma datos de infraestructura a conceptos de dominio
   */
  static dtoToContext(dto: HttpErrorDto): HttpErrorContext {
    return {
      status: dto.status,
      url: dto.url,
      method: dto.method,
      isLoginRequest: dto.url?.includes('login') || false,
    };
  }

  /**
   * Mapper completo: AxiosError -> Context
   * Combina ambas transformaciones en una sola operación
   */
  static axiosErrorToContext(error: AxiosError): HttpErrorContext {
    const dto = this.axiosErrorToDto(error);
    return this.dtoToContext(dto);
  }
}
